/**
 * Audio system configuration constants
 */

export const AUDIO_CONFIG = {
  // Dice roll stagger timing (milliseconds)
  DICE_STAGGER_MIN_MS: 100,
  DICE_STAGGER_MAX_MS: 200,

  // Ambience crossfade duration (seconds)
  CROSSFADE_DURATION_S: 2.5,

  // File extension for all audio files (change to .mp3, .m4a, etc. as needed)
  AUDIO_FILE_EXTENSION: '.mp3',

  // Default volume levels (0.0 to 1.0)
  DEFAULT_VOLUMES: {
    ambience: 0.5,
    music: 0.7,
    sfx: 0.8,
    master: 1.0
  },

  // localStorage key for volume settings
  STORAGE_KEY: 'diceSettlement_audioSettings',

  // Sounds to preload on app start (critical path)
  PRELOAD_SOUNDS: [
    'ui_confirm',
    'ui_back',
    'ui_open',
    'ui_close',
    'ui_error',
    'd6_roll',
    'd20_roll'
  ]
};
